module.exports = __webpack_public_path__ + "assets/ae4eae02e6ae5cc065ba91de31fda919.jpg";